import { getWebApp } from '@tg-web/utils';

import { CloudStorageKeys } from '../model/cloudStorageKeys';

export function getCloudStorageItem(key: keyof typeof CloudStorageKeys) {
  return new Promise<string | null>((resolve, reject) => {
    getWebApp().CloudStorage.getItem(key, (error, value) => {
      if (error) {
        reject(error);
      } else {
        resolve(value);
      }
    });
  });
}
